import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "d-inline ms-2" };
const _hoisted_2 = { class: "modal-title w-100 text-center fw-bold fs-4 mb-3" };
const _hoisted_3 = ["id"];
const _hoisted_4 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_5 = ["id", "data-bs-target", "aria-controls"];
const _hoisted_6 = {
    key: 0,
    class: "nav-item",
    role: "presentation"
};
const _hoisted_7 = {
    key: 0,
    class: "fw-bold ms-2"
};
const _hoisted_8 = {
    key: 0,
    class: "tab-content pt-3"
};
const _hoisted_9 = ["id", "tabindex"];
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = ["id", "value", "disabled", "onInput"];
const _hoisted_12 = ["for"];
const _hoisted_13 = {
    key: 0,
    class: "form-text"
};
const _hoisted_14 = {
    key: 0,
    class: "bg-light rounded p-2 mb-3"
};
const _hoisted_15 = ["href"];
const _hoisted_16 = ["id"];
const _hoisted_17 = { class: "small" };
const _hoisted_18 = {
    href: "/beispiele/personalisierte-konfiguration.xlsx",
    target: "_blank"
};
const _hoisted_19 = { key: 0 };
const _hoisted_20 = ["href"];
const _hoisted_21 = { class: "ms-2" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { key: 1 };
const _hoisted_24 = {
    class: "position-relative w-100 text-center border-start-3 border-secondary d-flex align-items-center justify-content-center rounded-bottom p-4",
    style: { "cursor": "pointer", "border-style": "dashed !important" }
};
const _hoisted_25 = ["onChange"];
const _hoisted_26 = { class: "fw-bold text-primary mb-0" };
const _hoisted_27 = { class: "form-check mb-3" };
const _hoisted_28 = ["id", "onUpdate:modelValue"];
const _hoisted_29 = ["for"];
const _hoisted_30 = { class: "mb-3 d-flex align-items-center flex-wrap" };
const _hoisted_31 = { class: "form-floating w-75" };
const _hoisted_32 = ["id", "onChange", "onUpdate:modelValue"];
const _hoisted_33 = ["value"];
const _hoisted_34 = ["for"];
const _hoisted_35 = { class: "w-25" };
const _hoisted_36 = { class: "d-flex justify-content-between mb-3" };
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = { class: "mb-3" };
const _hoisted_43 = ["for"];
const _hoisted_44 = { class: "d-flex align-items-center" };
const _hoisted_45 = ["id", "onChange", "value"];
const _hoisted_46 = ["onClick"];
const _hoisted_47 = { class: "ms-2" };
import PantoneColorPicker from '@/Configurator/Shared/PantoneColorPicker.vue';
import { Canvas, Control, Textbox, util } from 'fabric';
import { onMounted, ref, watch } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextManager',
    props: {
        configurationComponentId: String,
        maxTextsAmount: Number,
        initialCanvas: Canvas
    },
    emits: ['update', 'usedColors'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const instanceId = Math.random().toString(36).substring(2, 7);
        const maxTextsAmount = ref(3);
        const activeTextIndex = ref(0);
        const availableFonts = ref([]);
        const texts = ref([]);
        const loading = ref(false);
        const fileInput = ref(null);
        const individualTextId = ref(null);
        const individualTextFileUrl = ref(null);
        const validFileTypes = ref(['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']);
        const deleteImg = new Image();
        deleteImg.src = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
        const centerImg = new Image();
        centerImg.src = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%20class%3D%22bi%20bi-align-center%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cpath%20d%3D%22M8%201a.5.5%200%200%201%20.5.5V6h-1V1.5A.5.5%200%200%201%208%201m0%2014a.5.5%200%200%201-.5-.5V10h1v4.5a.5.5%200%200%201-.5.5M2%207a1%201%200%200%201%201-1h10a1%201%200%200%201%201%201v2a1%201%200%200%201-1%201H3a1%201%200%200%201-1-1z%22/%3E%3C/svg%3E";
        const modal = ref();
        // Helper functions for event handling
        function handleTextInput(textRecord, event) {
            const target = event.target;
            if (target) {
                setText(textRecord, target.value);
            }
        }
        function handleFontFamilyChange(textRecord, event) {
            const target = event.target;
            if (target) {
                setFontFamily(textRecord, target.value);
            }
        }
        function handleScaleChange(textRecord, event) {
            const target = event.target;
            if (target) {
                scaleText(textRecord, parseFloat(target.value));
            }
        }
        onMounted(async () => {
            availableFonts.value = await loadConfigs('texts.fonts');
            validFileTypes.value = await loadConfigs('texts.file_mime_types');
            if (props.initialCanvas) {
                props.initialCanvas.getObjects('Textbox').forEach((obj) => {
                    texts.value.push(obj);
                });
                props.initialCanvas.getObjects('text').forEach((obj) => {
                    texts.value.push(obj);
                });
                texts.value.forEach((text) => {
                    if (text.get('individualTextFileUrl')) {
                        individualTextFileUrl.value = text.get('individualTextFileUrl');
                        individualTextId.value = text.get('id');
                    }
                });
                registerEvents();
            }
            if (props.maxTextsAmount) {
                maxTextsAmount.value = props.maxTextsAmount;
            }
        });
        watch(() => texts.value.map(text => ({ text: text.text, visible: text.visible, fontFamily: text.fontFamily, fontSize: text.fontSize, fontWeight: text.fontWeight, fontStyle: text.fontStyle, scaleX: text.scaleX, fill: text.fill })), () => {
            emit('update', texts.value, 'text');
            countColors();
        }, { deep: true });
        function loadConfigs(id) {
            return axios.post(route('configurator.configs.load'), {
                id: id,
            })
                .then(function (response) {
                return response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function createText() {
            if (maxTextsAmount.value <= texts.value.length) {
                return;
            }
            let defaultText = t('Ihr Text');
            let defaultFontFamily = 'Times';
            let defaultColor = '#000000';
            let text = new Textbox(defaultText, {
                fontFamily: defaultFontFamily,
                fontSize: 30,
                textAlign: 'center',
                fill: defaultColor
            });
            text.set({
                left: props.initialCanvas ? (props.initialCanvas.width - text.width * text.scaleX) / 2 : 0,
                top: props.initialCanvas ? (props.initialCanvas.height - text.height * text.scaleY) / 2 : 0,
                borderColor: '#528399',
                cornerColor: '#528399',
                cornerSize: 10,
                transparentCorners: false,
                borderDashArray: [4, 4],
                cornerStyle: 'circle'
            });
            axios.post(route('configurator.printConfiguration.texts.store', props.configurationComponentId), {
                content: defaultText,
                color: defaultColor,
                font: defaultFontFamily
            })
                .then(function (response) {
                text.set('id', response.data.id);
                texts.value.push(text);
                registerEvents();
                activeTextIndex.value = texts.value.length - 1;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function setText(textRecord, value) {
            if (value) {
                textRecord.set('text', value);
                saveText(textRecord);
                forceRerendering(textRecord);
            }
        }
        function toggleBold(textRecord) {
            if (textRecord.fontWeight == 'normal') {
                textRecord.fontWeight = 'bold';
            }
            else if (textRecord.fontWeight == 'bold') {
                textRecord.fontWeight = 'normal';
            }
            forceRerendering(textRecord);
        }
        function toggleItalic(textRecord) {
            if (textRecord.fontStyle == 'normal') {
                textRecord.fontStyle = 'italic';
            }
            else if (textRecord.fontStyle == 'italic') {
                textRecord.fontStyle = 'normal';
            }
            forceRerendering(textRecord);
        }
        function scaleText(textRecord, value) {
            textRecord.scaleX = value;
            textRecord.scaleY = value;
        }
        function setColor(textRecord, color) {
            textRecord.fill = color.hex;
            saveText(textRecord);
            forceRerendering(textRecord);
        }
        function setTextAlign(textRecord, align) {
            textRecord.textAlign = align;
            forceRerendering(textRecord);
            // logChanges(textRecord);
        }
        function setFontFamily(textRecord, font) {
            textRecord.fontFamily = font;
            // forceRerendering(textRecord);
            // textRecord.fontFamily = 'Times';
            forceRerendering(textRecord);
            saveText(textRecord);
            // setTimeout(() => {
            //     textRecord.fontFamily = font;
            //     saveText(textRecord);
            //     forceRerendering(textRecord);
            // }, 1000);
        }
        function removeText(textRecord) {
            axios.delete(route('configurator.printConfiguration.texts.destroy', textRecord.get('id')))
                .then(function (response) {
                texts.value = texts.value.filter((text) => text.get('id') !== textRecord.get('id'));
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        async function uploadTextFile(index, textRecord) {
            let file = null;
            if (fileInput.value && Array.isArray(fileInput.value) && fileInput.value[index]) {
                file = fileInput.value[index].files?.[0] || null;
            }
            if (file) {
                loading.value = true;
                if (!validFileTypes.value.includes(file.type) && !validFileTypes.value.includes(file.type)) {
                    Swal.fire({
                        title: t('Achtung!'),
                        html: t('Dateityp ist nicht erlaubt'),
                        icon: 'error',
                        confirmButtonText: t("Weitermachen"),
                        confirmButtonColor: "#528399",
                        cancelButtonColor: "#dc3545",
                    });
                    loading.value = false;
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                axios.post(route('configurator.printConfiguration.texts.individual.store', {
                    configurationText: textRecord.get('id'),
                    configurationComponentId: props.configurationComponentId
                }), formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then(function (response) {
                    individualTextFileUrl.value = response.data.fileUrl;
                    individualTextId.value = textRecord.get('id');
                    textRecord.set('individualTextFileUrl', individualTextFileUrl.value);
                    setText(textRecord, response.data.longestTextEntry);
                    fileInput.value = null;
                    loading.value = false;
                })
                    .catch(function (error) {
                    console.log(error);
                    loading.value = false;
                    individualTextFileUrl.value = null;
                    individualTextId.value = null;
                });
            }
        }
        function removeTextFile(textRecord) {
            axios.delete(route('configurator.printConfiguration.texts.individual.destroy', textRecord.get('id')))
                .then(function (response) {
                individualTextFileUrl.value = null;
                individualTextId.value = null;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function countColors() {
            let usedColors = [];
            texts.value.forEach((text) => {
                if (text.fill) {
                    if (typeof text.fill === 'string' && !usedColors.includes(text.fill)) {
                        usedColors.push(text.fill);
                    }
                }
            });
            emit('usedColors', usedColors);
        }
        function forceRerendering(textRecord) {
            textRecord.scaleX = parseFloat(textRecord.scaleX + '') + 0.001;
            setTimeout(() => {
                textRecord.scaleX = parseFloat(textRecord.scaleX + '') - 0.001;
            }, 100);
        }
        function registerEvents() {
            texts.value.forEach((text) => {
                //Positioning
                var left1 = 0;
                var top1 = 0;
                var scale1x = 0;
                var scale1y = 0;
                var width1 = 0;
                var height1 = 0;
                text.on('scaling', (event) => {
                    const object = event.transform?.target;
                    object.setCoords();
                    var brNew = object.getBoundingRect();
                    if (object.canvas && (((brNew.width + brNew.left) >= object.canvas.width) || ((brNew.height + brNew.top) >= object.canvas.height) || ((brNew.left < 0) || (brNew.top < 0)))) {
                        object.left = left1;
                        object.top = top1;
                        object.scaleX = scale1x;
                        object.scaleY = scale1y;
                        object.width = width1;
                        object.height = height1;
                    }
                    else {
                        left1 = object.left;
                        top1 = object.top;
                        scale1x = object.scaleX;
                        scale1y = object.scaleY;
                        width1 = object.width;
                        height1 = object.height;
                    }
                    // Update the range slider value
                    const rangeSlider = document.getElementById(`fontSize-${texts.value.indexOf(object)}`);
                    if (rangeSlider) {
                        rangeSlider.value = object.scaleX.toString();
                    }
                });
                text.on('moving', (event) => {
                    const obj = event.transform?.target;
                    // if object is too big ignore
                    if (obj.canvas && (obj.height > obj.canvas.height || obj.width > obj.canvas.width)) {
                        return;
                    }
                    obj.setCoords();
                    // top-left  corner
                    if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
                        obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top) - 10;
                        obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left) - 10;
                    }
                    // bot-right corner
                    if (obj.canvas && (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width)) {
                        obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top) + 10;
                        obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left) + 10;
                    }
                });
                text.on('changed', () => {
                    const textarea = document.getElementById(`textarea-${texts.value.indexOf(text)}`);
                    if (textarea) {
                        textarea.value = text.text || '';
                    }
                    saveText(text);
                });
                text.on('selected', () => {
                    activeTextIndex.value = texts.value.indexOf(text);
                });
                registerDeleteControl(text);
                registerCenterObjectControl(text);
            });
        }
        function saveText(text) {
            axios.put(route('configurator.printConfiguration.texts.update', text.get('id')), {
                content: text.text,
                color: text.fill,
                font: text.fontFamily
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function registerDeleteControl(obj) {
            if (obj.get('editingBlocked') === true) {
                return;
            }
            obj.controls.deleteControl = new Control({
                x: 0.65,
                y: -0.55,
                offsetY: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: (_eventData, transform) => {
                    removeText(transform.target);
                },
                render: (ctx, left, top, _styleOverride, fabricObject) => {
                    const size = 28;
                    ctx.save();
                    ctx.translate(left, top);
                    ctx.rotate(util.degreesToRadians(fabricObject.angle));
                    ctx.drawImage(deleteImg, -size / 2, -size / 2, size, size);
                    ctx.restore();
                }
            });
        }
        function registerCenterObjectControl(obj) {
            if (obj.get('editingBlocked') == true) {
                return;
            }
            obj.controls.centerControl = new Control({
                x: 0.65,
                y: -0.15,
                offsetY: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: (_eventData, transform) => {
                    centerObjectInCanvas(transform.target);
                },
                render: (ctx, left, top, _styleOverride, fabricObject) => {
                    const size = 28;
                    ctx.save();
                    ctx.translate(left, top);
                    ctx.rotate(util.degreesToRadians(fabricObject.angle));
                    ctx.drawImage(centerImg, -size / 2, -size / 2, size, size);
                    ctx.restore();
                }
            });
        }
        function centerObjectInCanvas(obj) {
            if (props.initialCanvas) {
                obj.set({
                    left: (props.initialCanvas.width - obj.width * obj.scaleX) / 2,
                    top: (props.initialCanvas.height - obj.height * obj.scaleY) / 2,
                });
                emit('update', texts.value, 'text');
            }
        }
        function openTextManager(event) {
            if (texts.value.length == 0) {
                createText();
            }
            modal.value.open(event);
        }
        function logChanges(textRecord) {
            console.log(textRecord.scaleX);
            console.log(textRecord.scaleY);
            console.log(textRecord.fontWeight);
            console.log(textRecord.fontStyle);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    class: "btn btn-primary d-inline-flex align-items-center m-2",
                    onClick: _cache[0] || (_cache[0] = ($event) => (openTextManager($event)))
                }, [
                    _cache[2] || (_cache[2] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-textarea-t",
                        viewBox: "0 0 16 16"
                    }, [
                        _createElementVNode("path", { d: "M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" }),
                        _createElementVNode("path", { d: "M11.434 4H4.566L4.5 5.994h.386c.21-1.252.612-1.446 2.173-1.495l.343-.011v6.343c0 .537-.116.665-1.049.748V12h3.294v-.421c-.938-.083-1.054-.21-1.054-.748V4.488l.348.01c1.56.05 1.963.244 2.173 1.496h.386z" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('Text')), 1)
                ]),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal,
                    size: 'md',
                    closeButton: _unref(t)('weiter')
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('Text')), 1),
                        _createElementVNode("div", null, [
                            _createElementVNode("ul", {
                                class: "nav nav-pills mb-3",
                                id: 'texts-tab' + _unref(instanceId),
                                role: "tablist"
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(texts.value, (text, index) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_4, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["nav-link", { active: index === activeTextIndex.value }]),
                                            id: 'pills-tab-' + _unref(instanceId) + index,
                                            "data-bs-toggle": "pill",
                                            "data-bs-target": '#' + _unref(instanceId) + index,
                                            type: "button",
                                            role: "tab",
                                            "aria-controls": 'pills-' + index,
                                            "aria-selected": "true"
                                        }, _toDisplayString(_unref(t)('Text')) + " " + _toDisplayString(index + 1), 11, _hoisted_5)
                                    ]));
                                }), 256)),
                                (maxTextsAmount.value > texts.value.length)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                        _createElementVNode("button", {
                                            class: "btn d-inline-flex align-items-center",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (createText()))
                                        }, [
                                            _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "24",
                                                fill: "currentColor",
                                                class: "bi bi-plus-circle-fill text-primary",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" })
                                            ], -1)),
                                            (texts.value.length == 0)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('Text hinzufügen')), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 8, _hoisted_3),
                            (texts.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(texts.value, (textRecord, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["tab-pane fade", { active: index === activeTextIndex.value, show: index === activeTextIndex.value }]),
                                            id: '' + _unref(instanceId) + index,
                                            role: "tabpanel",
                                            tabindex: index
                                        }, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("textarea", {
                                                    class: "form-control",
                                                    placeholder: "Text",
                                                    id: 'textarea-' + _unref(instanceId) + index,
                                                    value: textRecord.text,
                                                    disabled: textRecord.get('id') === individualTextId.value,
                                                    onInput: ($event) => (handleTextInput(textRecord, $event))
                                                }, null, 40, _hoisted_11),
                                                _createElementVNode("label", {
                                                    for: 'textarea-' + index
                                                }, _toDisplayString(_unref(t)('Text')), 9, _hoisted_12),
                                                (textRecord.get('id') === individualTextId.value)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(t)('Es wird der längste Eintrag der hochgeladenen Datei als Beispiel-Text angezeigt.')), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            (individualTextId.value === null || individualTextId.value === textRecord.get('id'))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                    _createElementVNode("a", {
                                                        "data-bs-toggle": "collapse",
                                                        href: '#individualText-' + index,
                                                        class: "mb-3"
                                                    }, _toDisplayString(_unref(t)('Personalisieren')), 9, _hoisted_15),
                                                    _createElementVNode("div", {
                                                        class: "collapse",
                                                        id: 'individualText-' + index
                                                    }, [
                                                        _createElementVNode("p", _hoisted_17, [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Mit einer .xlsx-Datei nach folgendem Schema können Sie den Druck personalisieren:')) + " ", 1),
                                                            _createElementVNode("a", _hoisted_18, "(" + _toDisplayString(_unref(t)('Beispiel-Datei')) + ")", 1)
                                                        ]),
                                                        (individualTextFileUrl.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                                _createElementVNode("a", {
                                                                    href: individualTextFileUrl.value,
                                                                    target: "_blank",
                                                                    class: "d-flex align-items-center mb-2"
                                                                }, [
                                                                    _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        width: "16",
                                                                        height: "16",
                                                                        fill: "currentColor",
                                                                        class: "bi bi-filetype-xlsx",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", {
                                                                            "fill-rule": "evenodd",
                                                                            d: "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM7.86 14.841a1.13 1.13 0 0 0 .401.823q.195.162.479.252.284.091.665.091.507 0 .858-.158.355-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.565-.21l-.621-.144a1 1 0 0 1-.405-.176.37.37 0 0 1-.143-.299q0-.234.184-.384.188-.152.513-.152.214 0 .37.068a.6.6 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.199-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.44 0-.777.15-.336.149-.527.421-.19.273-.19.639 0 .302.123.524t.351.367q.229.143.54.213l.618.144q.31.073.462.193a.39.39 0 0 1 .153.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.168.07-.413.07-.176 0-.32-.04a.8.8 0 0 1-.249-.115.58.58 0 0 1-.255-.384zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036zm1.923 3.325h1.697v.674H5.266v-3.999h.791zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036z"
                                                                        })
                                                                    ], -1)),
                                                                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('Hochgeladene Datei')), 1)
                                                                ], 8, _hoisted_20),
                                                                _createElementVNode("button", {
                                                                    class: "btn btn-sm btn-danger",
                                                                    onClick: ($event) => (removeTextFile(textRecord))
                                                                }, _toDisplayString(_unref(t)('Löschen')), 9, _hoisted_22)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (individualTextFileUrl.value === null)
                                                            ? (_openBlock(), _createElementBlock("form", _hoisted_23, [
                                                                _createElementVNode("label", _hoisted_24, [
                                                                    _createElementVNode("input", {
                                                                        type: "file",
                                                                        ref_for: true,
                                                                        ref_key: "fileInput",
                                                                        ref: fileInput,
                                                                        onChange: ($event) => (uploadTextFile(index, textRecord)),
                                                                        class: "position-absolute w-100 h-100",
                                                                        style: { "opacity": "0" }
                                                                    }, null, 40, _hoisted_25),
                                                                    _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('Klicken oder Elemente hineinziehen')), 1)
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ], 8, _hoisted_16)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_27, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: 'visibleText-' + _unref(instanceId) + index,
                                                    "onUpdate:modelValue": ($event) => ((textRecord.visible) = $event)
                                                }, null, 8, _hoisted_28), [
                                                    [_vModelCheckbox, textRecord.visible]
                                                ]),
                                                _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: 'visibleText-' + index
                                                }, _toDisplayString(_unref(t)('Text anzeigen')), 9, _hoisted_29)
                                            ]),
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: 'fontFamily-' + _unref(instanceId) + index,
                                                        onChange: ($event) => (handleFontFamilyChange(textRecord, $event)),
                                                        "onUpdate:modelValue": ($event) => ((textRecord.fontFamily) = $event)
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFonts.value, (font) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: font.value,
                                                                style: _normalizeStyle('font-family: \'' + font.value + '\';')
                                                            }, _toDisplayString(font.name), 13, _hoisted_33));
                                                        }), 256))
                                                    ], 40, _hoisted_32), [
                                                        [_vModelSelect, textRecord.fontFamily]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'fontFamily-' + index
                                                    }, _toDisplayString(_unref(t)('Schriftart')), 9, _hoisted_34)
                                                ]),
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createVNode(PantoneColorPicker, {
                                                        id: index,
                                                        initialHexColor: typeof textRecord.fill === 'string' ? textRecord.fill : undefined,
                                                        onUpdate: ($event) => (setColor(textRecord, $event))
                                                    }, null, 8, ["id", "initialHexColor", "onUpdate"])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["btn btn-outline-primary d-inline-flex align-items-center me-2", { 'active': textRecord.fontWeight === 'bold' }]),
                                                        onClick: ($event) => (toggleBold(textRecord))
                                                    }, [...(_cache[5] || (_cache[5] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                height: "20",
                                                                fill: "currentColor",
                                                                class: "bi bi-type-bold",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M8.21 13c2.106 0 3.412-1.087 3.412-2.823 0-1.306-.984-2.283-2.324-2.386v-.055a2.176 2.176 0 0 0 1.852-2.14c0-1.51-1.162-2.46-3.014-2.46H3.843V13zM5.908 4.674h1.696c.963 0 1.517.451 1.517 1.244 0 .834-.629 1.32-1.73 1.32H5.908V4.673zm0 6.788V8.598h1.73c1.217 0 1.88.492 1.88 1.415 0 .943-.643 1.449-1.832 1.449H5.907z" })
                                                            ], -1)
                                                        ]))], 10, _hoisted_37),
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["btn btn-outline-primary d-inline-flex align-items-center", { 'active': textRecord.fontStyle === 'italic' }]),
                                                        onClick: ($event) => (toggleItalic(textRecord))
                                                    }, [...(_cache[6] || (_cache[6] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                height: "20",
                                                                fill: "currentColor",
                                                                class: "bi bi-type-italic",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M7.991 11.674 9.53 4.455c.123-.595.246-.71 1.347-.807l.11-.52H7.211l-.11.52c1.06.096 1.128.212 1.005.807L6.57 11.674c-.123.595-.246.71-1.346.806l-.11.52h3.774l.11-.52c-1.06-.095-1.129-.211-1.006-.806z" })
                                                            ], -1)
                                                        ]))], 10, _hoisted_38)
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["btn btn-outline-primary d-inline-flex align-items-center me-2", { 'active': textRecord.textAlign === 'left' }]),
                                                        onClick: ($event) => (setTextAlign(textRecord, 'left'))
                                                    }, [...(_cache[7] || (_cache[7] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                height: "20",
                                                                fill: "currentColor",
                                                                class: "bi bi-text-left",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
                                                                })
                                                            ], -1)
                                                        ]))], 10, _hoisted_39),
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["btn btn-outline-primary d-inline-flex align-items-center me-2", { 'active': textRecord.textAlign === 'center' }]),
                                                        onClick: ($event) => (setTextAlign(textRecord, 'center'))
                                                    }, [...(_cache[8] || (_cache[8] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                height: "20",
                                                                fill: "currentColor",
                                                                class: "bi bi-text-center",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M4 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
                                                                })
                                                            ], -1)
                                                        ]))], 10, _hoisted_40),
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["btn btn-outline-primary d-inline-flex align-items-center", { 'active': textRecord.textAlign === 'right' }]),
                                                        onClick: ($event) => (setTextAlign(textRecord, 'right'))
                                                    }, [...(_cache[9] || (_cache[9] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                height: "20",
                                                                fill: "currentColor",
                                                                class: "bi bi-text-right",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
                                                                })
                                                            ], -1)
                                                        ]))], 10, _hoisted_41)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_42, [
                                                _createElementVNode("label", {
                                                    for: 'fontSize-' + index,
                                                    class: "form-label fw-bold"
                                                }, _toDisplayString(_unref(t)('Schriftgröße')), 9, _hoisted_43),
                                                _createElementVNode("div", _hoisted_44, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "24",
                                                        fill: "currentColor",
                                                        class: "bi bi-alphabet",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M2.204 11.078c.767 0 1.201-.356 1.406-.737h.059V11h1.216V7.519c0-1.314-.947-1.783-2.11-1.783C1.355 5.736.75 6.42.69 7.27h1.216c.064-.323.313-.552.84-.552s.864.249.864.771v.464H2.346C1.145 7.953.5 8.568.5 9.496c0 .977.693 1.582 1.704 1.582m.42-.947c-.44 0-.845-.235-.845-.718 0-.395.269-.684.84-.684h.991v.538c0 .503-.444.864-.986.864m5.593.937c1.216 0 1.948-.869 1.948-2.31v-.702c0-1.44-.727-2.305-1.929-2.305-.742 0-1.328.347-1.499.889h-.063V3.983h-1.29V11h1.27v-.791h.064c.21.532.776.86 1.499.86Zm-.43-1.025c-.66 0-1.113-.518-1.113-1.28V8.12c0-.825.42-1.343 1.098-1.343.684 0 1.075.518 1.075 1.416v.45c0 .888-.386 1.401-1.06 1.401Zm2.834-1.328c0 1.47.87 2.378 2.305 2.378 1.416 0 2.139-.777 2.158-1.763h-1.186c-.06.425-.313.732-.933.732-.66 0-1.05-.512-1.05-1.352v-.625c0-.81.371-1.328 1.045-1.328.635 0 .879.425.918.776h1.187c-.02-.986-.787-1.806-2.14-1.806-1.41 0-2.304.918-2.304 2.338z" })
                                                    ], -1)),
                                                    _createElementVNode("input", {
                                                        type: "range",
                                                        class: "form-range mx-2",
                                                        id: 'fontSize-' + _unref(instanceId) + index,
                                                        onChange: ($event) => (handleScaleChange(textRecord, $event)),
                                                        value: textRecord.scaleX,
                                                        min: "0.1",
                                                        max: "2",
                                                        step: "0.1"
                                                    }, null, 40, _hoisted_45),
                                                    _cache[11] || (_cache[11] = _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "40",
                                                        fill: "currentColor",
                                                        class: "bi bi-alphabet",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M2.204 11.078c.767 0 1.201-.356 1.406-.737h.059V11h1.216V7.519c0-1.314-.947-1.783-2.11-1.783C1.355 5.736.75 6.42.69 7.27h1.216c.064-.323.313-.552.84-.552s.864.249.864.771v.464H2.346C1.145 7.953.5 8.568.5 9.496c0 .977.693 1.582 1.704 1.582m.42-.947c-.44 0-.845-.235-.845-.718 0-.395.269-.684.84-.684h.991v.538c0 .503-.444.864-.986.864m5.593.937c1.216 0 1.948-.869 1.948-2.31v-.702c0-1.44-.727-2.305-1.929-2.305-.742 0-1.328.347-1.499.889h-.063V3.983h-1.29V11h1.27v-.791h.064c.21.532.776.86 1.499.86Zm-.43-1.025c-.66 0-1.113-.518-1.113-1.28V8.12c0-.825.42-1.343 1.098-1.343.684 0 1.075.518 1.075 1.416v.45c0 .888-.386 1.401-1.06 1.401Zm2.834-1.328c0 1.47.87 2.378 2.305 2.378 1.416 0 2.139-.777 2.158-1.763h-1.186c-.06.425-.313.732-.933.732-.66 0-1.05-.512-1.05-1.352v-.625c0-.81.371-1.328 1.045-1.328.635 0 .879.425.918.776h1.187c-.02-.986-.787-1.806-2.14-1.806-1.41 0-2.304.918-2.304 2.338z" })
                                                    ], -1))
                                                ])
                                            ]),
                                            (!(textRecord.get('editingBlocked') === true))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    class: "btn btn-danger d-inline-flex align-items-center",
                                                    onClick: ($event) => (removeText(textRecord))
                                                }, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-trash",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" }),
                                                        _createElementVNode("path", { d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" })
                                                    ], -1)),
                                                    _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('Text löschen')), 1)
                                                ], 8, _hoisted_46))
                                                : _createCommentVNode("", true)
                                        ], 10, _hoisted_9));
                                    }), 256))
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["closeButton"])
            ], 64));
        };
    }
});
